module.exports = __webpack_public_path__ + "static/media/temp.1d2ee41f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/code-images/temp.jpg
// module id = 104
// module chunks = 0